module.exports = __webpack_public_path__ + "media/brands/Vendors_Dynamic_Products_2-8a6cc2ca.jpg";